module.exports = __webpack_public_path__ + "img/logo.df19134e.jpg";